import React from 'react';

import { hasPermission, hasActiveFeatureGate } from '@ubisend/pulse-auth';

import ViberLink from './Pages/index';

const routes = [
  {
    name: 'Viber',
    path: '/viber-link',
    component: () => <ViberLink />,
    canAccess: [
      hasActiveFeatureGate('channel - viber'),
      hasPermission('view viber settings')
    ],
    actions: [
      {
        title: 'Manage your Viber channel',
        description: 'Connect, disconnect, or edit your viber integration.',
        icon: 'lightningBolt'
      }
    ]
  }
];

export default routes;
